import type {
    EditionFragment as Edition,
    UpdateEdition_editionUpdate_edition_emailTemplate_links as Link,
} from 'nutshell-graphql-types';

export const mapEditionLinksToDripSequenceDropdown = (dripSequenceEditions: Edition[]) => {
    const bucketedLinks = dripSequenceEditions.reduce<Record<string, any>>(
        (acc, currentEdition) => {
            const links = currentEdition.emailTemplate ? currentEdition.emailTemplate.links : [];

            links.forEach((link: Link) => {
                const url = link.link;

                if (typeof url === 'string' && acc[url]) {
                    acc[url] = {
                        ...acc[url],
                        secondLine:
                            typeof acc[url].secondLine === 'number' ? acc[url].secondLine + 1 : 2,
                    };
                } else {
                    acc[url] = {
                        value: url,
                        secondLine: currentEdition.name,
                    };
                }
            });

            return acc;
        },
        {}
    );

    const linksInArray = Object.keys(bucketedLinks).map((key) => {
        return bucketedLinks[key];
    });

    return linksInArray;
};
